import { Typography } from '@material-ui/core'
import React from 'react'

const I2pheading = () => {
  return (
    <>
      <Typography style={{ margin: '5px 8px' }}>
        <span style={{ color: "#0095DA", fontSize: '20px', paddingLeft: '5px' }}>I2P /</span><span style={{ color: "#2c3238", fontSize: '20px' }}> Home</span>
      </Typography>
    </>
  )
}

export default I2pheading
